import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const ExportRawRepository = RepositoryFactory.get('exportRaw')

class ExportRawService {
  static async getRawExecutions (params) {
    try {
      return await ExportRawRepository.getRawExecutions(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getRawExecutionsDetails (params) {
    try {
      return await ExportRawRepository.getRawExecutionsDetails(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default ExportRawService
